import React from 'react'

import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

import TipoDespesaReceitaService from '../../app/service/TipoDespesaReceita'
import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import { AuthContext } from '../../main/ProvedorAutenticacao'

class TiposDespesasReceitas extends React.Component {
  constructor(props) {
    super(props);

    this.tipoDespesaReceitaService = new TipoDespesaReceitaService();

    this.acoes = this.acoes.bind(this);
    this.onChangeTipo = this.onChangeTipo.bind(this);
    this.renderFooterCadastroTipos = this.renderFooterCadastroTipos.bind(this);
    this.renderFooterAlterarTipos = this.renderFooterAlterarTipos.bind(this);
    this.accept = this.accept.bind(this);

    this.state = {
      //cadastro
      codigo: '',
      tipoDespesaReceita: null,
      nome: '',
      tipo: null,
      empresa: null,
      tipos: [],
      modalCadastro: false,
      modalAlterar: false,
      visivble: false,
      detail: ''
    };

    this.tiposCodigos = [
      {codigo: 'D', nome: 'Despesa'},
      {codigo: 'R', nome: 'Receita'}
    ]
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  limparCampos = () => {
    this.setState({nome: ''});
  }

  listarTipos = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado

    await this.tipoDespesaReceitaService.listarTiposDespesasReceitas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Despesas e Receitas', detail:`${this.state.detail}`, life: 4000});
      })

      this.setState({classeDiv: 'hide'});
  }

  cadastrarTopoDespesaReceita = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Despesa e Receitas', detail:'Informe o nome do Tipo de Despesa ou Receita', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipo == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Despesa e Receitas', detail:'Informe o tipo de Despesa ou Receita', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    await this.tipoDespesaReceitaService.cadastrarTipoDespesaReceita({
      nome: this.state.nome,
      tipo: this.state.tipo.codigo,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Tipos de Despesa e Receitas', detail:'Tipo de Despesa ou receita cadastrada com sucesso', life: 4000});
      this.listarTipos();
      this.fecharModalCadastro('modalCadastro');
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Tipos de Despesas e Receitas', detail:`${this.state.detail}`, life: 4000});
    })
  }

  async consultarTipoDespesaReceita(tipo) {
    await this.tipoDespesaReceitaService.consultarTipoDespesaReceita(tipo.codigo)
      .then(response => {
        this.setState({tipoDespesaReceita: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        if(response.data.tipo == 'D') {
          this.setState({tipo: {
            codigo: 'D',
            nome: 'Despesa'
          }})
        } else {
          this.setState({tipo: {
            codigo: 'R',
            nome: 'Receita'
          }})
        }
        this.setState({empresa: response.data.empresa});
        this.abrirModaAlterar('modalAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Tipos de Despesas e Receitas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTipoDespesaReceita(rowData)}
                tooltip="Editar Tipo de Despesa ou receita" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Tipo de Receita ou Despesa" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  alterarTiposDespesaReceita = async () => {
    this.setState({classeDiv: 'show'});
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Despesa e Receitas', detail:'Informe o nome do Tipo de Despesa ou Receita', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    if(this.state.tipo == '') {
      this.toast.show({severity:'error', summary: 'Tipos de Despesa e Receitas', detail:'Informe o tipo de Despesa ou Receita', life: 4000});
      this.setState({classeDiv: 'hide'});
      return false;
    }

    this.tipoDespesaReceitaService.alterarTipoDespesaReceita({
      codigo: this.state.codigo,
      nome: this.state.nome,
      tipo: this.state.tipo.codigo,
      empresa: usuarioLogado.empresa
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Tipos de Despesa e Receitas', detail:'Tipo de Despesa e Receita alterado com sucesso', life: 4000});
      this.listarTipos();
      this.fecharModalCadastro('modalAlterar')
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Tipos de Despesas e Receitas', detail:`${this.state.detail}`, life: 4000});
      this.setState({classeDiv: 'hide'});
    })

    this.setState({classeDiv: 'hide'});
  }

  renderFooterCadastroTipos(name) {
    return (
        <div>
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
            &nbsp;
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTopoDespesaReceita}/>

        </div>
    );
  }

  renderFooterAlterarTipos(name) {
    return (
        <div>
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTiposDespesaReceita}/>

        </div>
    );
  }

  componentDidMount() {
    this.listarTipos();
  }

  onChangeTipo(e) {
    this.setState({tipo: e.value});
  }

  confirmaExclusao(tipo) {
    this.setState({codigo: tipo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Tipo de Despesa ou Receita?',
        header: 'Exclusão de Tipos de Despesas ou Receitas',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirTipoDespesaReceita = async() => {
    this.setState({classeDiv: 'show'});
    await this.tipoDespesaReceitaService.excluirTipoDespesaReceita(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Tipos de Despesas e Receitas', detail:'Tipo de Despsa ou Receita excluído com sucesso', life: 4000});
        this.listarTipos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Garantias de Processo', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({classeDiv: 'hide'});
  }

  accept() {
    this.excluirTipoDespesaReceita();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        {/**Cadastro de Tipos de Despesas e Receitas */}
        <div className="content-wrapper">
          <Dialog header="Cadastro de Tipos de Despesas e Receitas"
                  visible={this.state.modalCadastro} 
                  style={{ width: '40vw' }} 
                  footer={this.renderFooterCadastroTipos('modalCadastro')} 
                  onHide={() => this.fecharModalCadastro('modalCadastro')}>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label htmlFor="tipo">Tipo</label>
                    <Dropdown value={this.state.tipo} 
                              options={this.tiposCodigos} style={{width: '100%', height: '37px'}}
                              optionLabel="nome" 
                              onChange={this.onChangeTipo}
                              id="tipoPagamento"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label htmlFor="nomeTipo">Nome</label>
                    <InputText id="nomeTipo" 
                                type="text" 
                                value={this.state.nome} style={{width: '100%', height: '37px'}}
                                onChange={e => this.setState({nome: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
          </Dialog>
          {/**Alterar Tipos de Despesas e Receitas */}
          <Dialog header="Alterar Tipos de Despesas e Receitas"
                  visible={this.state.modalAlterar} 
                  style={{ width: '40vw' }} 
                  footer={this.renderFooterAlterarTipos('modalAlterar')} 
                  onHide={() => this.fecharModalCadastro('modalAlterar')}>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label htmlFor="tipoAlterar">Tipo</label>
                    <Dropdown value={this.state.tipo} 
                              options={this.tiposCodigos} style={{width: '100%', height: '37px'}}
                              optionLabel="nome" 
                              onChange={this.onChangeTipo}
                              id="tipoAlterar"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label htmlFor="nomeTipoAlterar">Nome</label>
                    <InputText id="nomeTipoAlterar" 
                                type="text" 
                                value={this.state.nome} style={{width: '100%', height: '37px'}}
                                onChange={e => this.setState({nome: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
          </Dialog>
          <ConfirmDialog visible={this.state.visible} 
                         onHide={() => this.setState({ visible: false })} 
                         message="Are you sure you want to proceed?"
                         header="Confirmation"
                         icon="pi pi-exclamation-triangle" 
                         accept={() => this.excluirTipoDespesaReceita} 
                         reject={() => this.setState({visible: false})}/>

          <section className="content-header">
              <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fas fa-hand-holding-usd"></i>
                          <span> Tipos de Despesas e Receitas</span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-5">
                            <span className="input-group">
                              <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      onClick={() => this.abrirModalCadastro('modalCadastro')}
                                      data-toggle="modal" 
                                      data-target="#modal-default">
                              <i className="fas fa-plus"></i> Adicionar</button>
                            </span>
                          </div>
                        </div>
                      <Progresso classeSecundaria={this.state.classeDiv}/>
                      </div>
                      <DataTable value={this.state.tipos}  paginator responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum Tipo de Despesa ou receita cadastrados" rows={10}>
                        <Column field="nome" header="Nome"></Column>
                        <Column field="tipoCalculado" header="Tipo"></Column>
                        <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
      </>
    )
  }
}

TiposDespesasReceitas.contextType = AuthContext;
export default withRouter (TiposDespesasReceitas)
